// extracted by mini-css-extract-plugin
export default {"SOTMI":"FPR_SOTMI__hLvXD"};